import type { VerdictKey } from '@/types/content';

export interface VerdictMeta {
  key: VerdictKey;
  label: string;
  short: string;
  desc: string;
  icon: string;
  badge: string;
  dot: string;
}

export const verdictMeta: Record<VerdictKey, VerdictMeta> = {
  confirmed: {
    key: 'confirmed',
    label: '实锤成立',
    short: '实锤',
    desc: '多方证据交叉印证，核心信息已被证实。',
    icon: 'ri-shield-check-line',
    badge: 'bg-primary-100 text-primary-800 border border-primary-200',
    dot: 'bg-primary-500',
  },
  debunked: {
    key: 'debunked',
    label: '已辟谣',
    short: '辟谣',
    desc: '关键信息被证伪，或当事人已给出可信回应。',
    icon: 'ri-shield-cross-line',
    badge: 'bg-secondary-100 text-secondary-800 border border-secondary-200',
    dot: 'bg-secondary-500',
  },
  partial: {
    key: 'partial',
    label: '部分属实',
    short: '部分属实',
    desc: '确有此事，但传播过程中被夸大或拼接。',
    icon: 'ri-error-warning-line',
    badge: 'bg-accent-100 text-accent-900 border border-accent-200',
    dot: 'bg-accent-500',
  },
  pending: {
    key: 'pending',
    label: '仍在核实',
    short: '存疑',
    desc: '证据不足或互相矛盾，暂不下结论。',
    icon: 'ri-question-line',
    badge: 'bg-background-200 text-foreground-700 border border-background-300',
    dot: 'bg-foreground-400',
  },
};

export const verdictOrder: VerdictKey[] = ['confirmed', 'partial', 'debunked', 'pending'];

export function credibilityLabel(score: number): string {
  if (score >= 85) return '可信度极高';
  if (score >= 70) return '较可信';
  if (score >= 50) return '需谨慎';
  return '可信度低';
}

export function credibilityBarClass(score: number): string {
  if (score >= 85) return 'bg-primary-500';
  if (score >= 70) return 'bg-accent-500';
  if (score >= 50) return 'bg-accent-400';
  return 'bg-foreground-300';
}